import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { autofill } from 'redux-form';
import { CLIENT_ALLOWANCE_ITEM_FORM } from 'src/constants/FormNames';

import classNames from 'classnames';
import selector from 'src/utils/Utils';

import { getSelectOptions } from 'src/reducers/selectOptions';

import { CLIENT_ALLOWANCE_ITEMS } from 'src/constants/EndpointUrls';
import { FormSubmitBtn, CancelBtn } from 'src/buttons';
import { ErrorsSection, SimpleConfirmModal } from 'src/components';

import { TextField, SelectField, RadioField, CheckboxField, Label, Section } from 'src/jbc-front/components/Form';
import * as CssClassNames from 'src/constants/CssClassNames';
import { getAllowanceItemFormValues } from 'src/reducers/clients/allowanceItems';

import styles from './AllowanceItemEditingForm.scss';
import { withTranslation, useTranslation } from 'react-i18next';

const JOBCAN_ITEM_LIST = '/coordinations/sync_jbc_settings';
const DESCRIPTION_URL =
  'https://jobcan.zendesk.com/hc/ja/articles/205211775-%E9%A0%85%E7%9B%AE%E4%B8%80%E8%A6%A7-%E3%83%BC-%E5%8B%A4%E5%8B%99%E3%83%87%E3%83%BC%E3%82%BF%E3%83%80%E3%82%A6%E3%83%B3%E3%83%AD%E3%83%BC%E3%83%89';

const PayrollRulesGroupCheckBoxList = ({ clientPayrollRulesGroups, isEditablePayrollRulesGroup }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Label text={t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.applicable_salary_rule_group')} />
      <p className={styles.note}>{t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.If_not_selected_attendance_data_cannot_be_acquired')}</p>
      <div className={styles.boxlistWrap}>
        {clientPayrollRulesGroups.map(group => (
          <CheckboxField
            key={group.value}
            name={`payrollRulesGroups["${group.value}"]`}
            label={group.label}
            width={10}
            disabled={!isEditablePayrollRulesGroup}
          />
        ))}
      </div>
    </div>
  );
};

class AllowanceItemEditingForm extends React.Component {
  state = {
    unitTypeModalOpen: false
  };

  openModal = () => {
    this.setState({ ...this.state, unitTypeModalOpen: true });
  };

  closeModal = () => {
    this.setState({ ...this.state, unitTypeModalOpen: false });
  };

  selectableJobcanOptions = () => {
    const { selectingUnitType, selectableJobcanRelatedColumn } = this.props;
    return selectableJobcanRelatedColumn.filter(item => item.unitType === selectingUnitType);
  };

  isPredeterminedWorkingTime = itemCode => itemCode === 'predetermined_working_time';

  render() {
    const UNIT_TYPE_OPTIONS = [
      { value: 'number_of_days', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.days') },
      { value: 'time', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.hours') },
      { value: 'number_of_times', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.times') }
    ];
    const PAYSLIP_DISPLAY_TYPES = [
      { value: 'display_positive_number', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.hide_from_payslip_if_the_value_is_0') },
      { value: 'always', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.always_show_in_payslip') },
      { value: 'non_display', label: this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.do_not_show_in_payslip') }
    ];
    const {
      submitting,
      submit,
      handleSubmit,
      errors,
      clientPayrollRulesGroups,
      unitTypeChangeable,
      resetJobcanAttendanceRelatedColumnName,
      isCooperateWithJobcan,
      isEditablePayrollRulesGroup,
      isEditableJobcanAttendanceRelation,
      initialValues,
      selectingUnitType,
      id,
      orgUnitType
    } = this.props;
    const { itemCode, originalName } = initialValues;
    const submitAction = id && selectingUnitType !== orgUnitType ? this.openModal : submit;

    return (
      <div>
        <Section>
          <form className={classNames(CssClassNames.FORM, CssClassNames.EMPLOYEE_FORM)} onSubmit={handleSubmit}>
            <div>
              <ErrorsSection errors={errors} />
              <TextField
                name="name"
                label={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.item_name')}
                required
                maxLength="100"
                note={
                  <div>
                    {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.name_shown_in_payslip')}
                    {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Changed_item_names_will_all_be_reflected_in_payslip_payroll_book_and_provision_deduction_list')}
                    {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Only_item_name_will_be_changed_while_data_remains_the_same')}
                  </div>
                }
              />
              {itemCode && <p className={styles.payslipNote}>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Original_item_name')}{originalName}</p>}

              <RadioField
                label={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Unit')}
                name="unitType"
                options={UNIT_TYPE_OPTIONS}
                onChange={resetJobcanAttendanceRelatedColumnName}
                disabled={!unitTypeChangeable}
              />
              <SelectField name="payslipDisplayType" label={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.show_payslip')} options={PAYSLIP_DISPLAY_TYPES} />
              <p className={styles.payslipNote}>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Can_set_condition_for_showing_in_payslip_or_not')}</p>
              <PayrollRulesGroupCheckBoxList
                clientPayrollRulesGroups={clientPayrollRulesGroups}
                isEditablePayrollRulesGroup={isEditablePayrollRulesGroup}
              />

              <Label text={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.JOBCAN_link')} />

              {!this.isPredeterminedWorkingTime(itemCode) && (
                <React.Fragment>
                  <CheckboxField
                    name="isCooperateWithJobcanAttendance"
                    label={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Link_with_JOBCAN_Attendance')}
                    onChange={resetJobcanAttendanceRelatedColumnName}
                    disabled={!isEditableJobcanAttendanceRelation}
                    noteWidth={340}
                    note={
                      <div>
                        <ul className={styles.listOrder}>
                          <li>
                            {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.1_To_link_with_JOBCAN_Attendance')}<a href={JOBCAN_ITEM_LIST}>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.click_here')}</a>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.to_proceed_separately')}
                          </li>
                          <li>
                            {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.2_For_explanation_of_each_item')}<a href={DESCRIPTION_URL}>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.click_here')}</a>{this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.see_here')}
                          </li>
                        </ul>
                      </div>
                    }
                  />
                  {isCooperateWithJobcan && (
                    <SelectField
                      name="jobcanAttendanceRelatedColumnName"
                      width={450}
                      options={this.selectableJobcanOptions()}
                      disabled={!isEditableJobcanAttendanceRelation}
                    />
                  )}
                </React.Fragment>
              )}
              {this.isPredeterminedWorkingTime(itemCode) && (
                <p className="u-ml20">
                  {this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.Value_automatically_calculated_from_prescribed_work_days_in_the_month_x_salary_rules_prescribed_work_hours_in_1_day_when_linking_with_JOBCAN_Attendance_will_be_input')}
                </p>
              )}
            </div>
          </form>
        </Section>
        <div className="u-ta-c">
          <CancelBtn href={CLIENT_ALLOWANCE_ITEMS} className="u-mr20" />
          <FormSubmitBtn text={this.props.t('components.BonusFormModal.Save')} {...{ submitting }} submit={submitAction} />
        </div>
        <SimpleConfirmModal
          isOpen={this.state.unitTypeModalOpen}
          hideModal={this.closeModal}
          body={this.props.t('features.ClientAllowanceItems.components.AllowanceItemEditingForm.If_you_change_the_unit_all_data_in_the_input_process_will_be_deleted_Do_you_want_to_proceed')}
          onClick={() => {
            submit();
            this.closeModal();
          }}
          confirmBtnText={this.props.t('components.BonusFormModal.Save')}
        />
      </div>
    );
  }
}

export default withTranslation('translation')(connect(
  state => ({
    clientPayrollRulesGroups: getSelectOptions(state, 'clientPayrollRulesGroups'),
    unitTypeChangeable: selector(getAllowanceItemFormValues(state), 'unitTypeChangeable'),
    selectingUnitType: selector(getAllowanceItemFormValues(state), 'unitType'),
    id: selector(getAllowanceItemFormValues(state), 'id'),
    selectableJobcanRelatedColumn: getSelectOptions(state, 'selectableJobcanRelatedColumn'),
    isCooperateWithJobcan: selector(getAllowanceItemFormValues(state), 'isCooperateWithJobcanAttendance'),
    isEditablePayrollRulesGroup: selector(getAllowanceItemFormValues(state), 'isEditablePayrollRulesGroup'),
    isEditableJobcanAttendanceRelation: selector(
      getAllowanceItemFormValues(state),
      'isEditableJobcanAttendanceRelation'
    )
  }),
  dispatch => ({
    resetJobcanAttendanceRelatedColumnName: () => {
      dispatch(autofill(CLIENT_ALLOWANCE_ITEM_FORM, 'jobcanAttendanceRelatedColumnName', ''));
    }
  })
)(AllowanceItemEditingForm));
